// extracted by css-extract-rspack-plugin
export default {"clippedMessage":"clipped-message--_udTeKsTL7wRE3jq","messageTrigger":"message-trigger--U0ZWcoqyDskky7um"};